// extracted by mini-css-extract-plugin
module.exports = {"root":"member-operations__ModalOverlay__root","modal":"member-operations__ModalOverlay__modal","dim":"member-operations__ModalOverlay__dim"};